import { useMemo } from "react";
import { SERVICE_LABELS, SERVICE_DESCRIPTIONS, SERVICE_COLORS, STEP_LABELS } from "../constants";
import { formatMs } from "../utils";

export default function ServiceCard({ service, stats, isExpanded, onClick }) {
  const label = SERVICE_LABELS[service] || service;
  const desc = SERVICE_DESCRIPTIONS[service] || "";
  const color = SERVICE_COLORS[service] || "#89b8a5";
  const avgMs = stats?.avg_ms?.[service];

  // Extract real step data from stats.steps (format: "seraph:face_detect" -> avg_ms)
  const stepData = useMemo(() => {
    if (!stats?.steps) return [];
    const prefix = `${service}:`;
    return Object.entries(stats.steps)
      .filter(([key]) => key.startsWith(prefix))
      .map(([key, ms]) => {
        const stepName = key.replace(prefix, "");
        return {
          name: stepName,
          label: STEP_LABELS[stepName] || stepName,
          ms: ms,
        };
      })
      .sort((a, b) => b.ms - a.ms); // Sort by duration descending
  }, [stats?.steps, service]);

  return (
    <div
      className={`service-card ${isExpanded ? "expanded" : ""}`}
      style={{
        "--service-color": color,
        borderColor: isExpanded ? color : undefined,
      }}
      onClick={onClick}
    >
      <div className="service-header">
        <div className="service-indicator">
          <div className="service-color" style={{ background: color }} />
          <div className="service-pulse" style={{ background: color }} />
        </div>
        <div className="service-info">
          <div className="service-name">{label}</div>
          <div className="service-desc">{desc}</div>
        </div>
        <div className="service-stats">
          <div className="service-time" style={{ color }}>
            {formatMs(avgMs)}
          </div>
          <div className="service-expand">{isExpanded ? "v" : ">"}</div>
        </div>
      </div>
      {isExpanded && (
        <div className="service-steps">
          <div className="steps-header">
            <span>Step</span>
            <span>Avg Time</span>
          </div>
          {stepData.length > 0 ? (
            stepData.map((step) => (
              <div key={step.name} className="step-row">
                <span className="step-name">
                  <span className="step-bullet" style={{ background: color }} />
                  {step.label}
                </span>
                <span className="step-time">{formatMs(step.ms)}</span>
              </div>
            ))
          ) : (
            <div className="step-note">No step data available yet</div>
          )}
        </div>
      )}
    </div>
  );
}
